var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg12PxPhone = function Svg12PxPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.028 8.29.816-.947a.77.77 0 0 1 .914-.223l1.784.728a.77.77 0 0 1 .433.898l-.51 1.553c-.139.425-.545.723-.99.687a9.22 9.22 0 0 1-5.786-2.68l.005.005a9.22 9.22 0 0 1-2.68-5.786c-.036-.446.263-.851.687-.99l1.553-.51a.77.77 0 0 1 .898.433l.728 1.784a.77.77 0 0 1-.223.914l-.947.816"
  })));
};
export default Svg12PxPhone;